module.exports = "<div ui-view\n  ng-cloak>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/train/templates/index.html
// module id = 1524
// module chunks = 0